import { formatCurrencyToPtBr } from '../../../../../../../utils/currency';
import { round } from '../../../../../../../utils/math';
import { SuppliersResponseContentProps } from '../../NegociacaoFornecedor.types';
import {
  CostNegotiationMode,
  DEFAULT_COST_NEGOTIATION_MODE,
  getAgreedAllowanceInCostBase,
  getCurrentInputCostForNegotiation,
  isClosedRowWithoutCostSnapshot,
  resolveCostNegotiationModeForRow,
} from '../../costNegotiation';
import { idealPurchasePriceOf } from '../../utils';
import styles from './BestBuyPriceIndicator.module.scss';

export interface IBestBuyPriceIndicator {
  data?: SuppliersResponseContentProps;
  isSupplierModal?: boolean;
  costNegotiationMode?: CostNegotiationMode;
  /** Linha de negociação fechada: sem fotografia de custo, o preço ideal não é exibido. */
  isClosedNegotiation?: boolean;
}

export const BestBuyPriceIndicator = ({
  data,
  isSupplierModal = false,
  costNegotiationMode = DEFAULT_COST_NEGOTIATION_MODE,
  isClosedNegotiation = false,
}: IBestBuyPriceIndicator) => {
  // Em negociacao fechada a linha carrega a base congelada, que pode diferir da tabela. Tudo aqui --
  // preco ideal, custo comparado e verba -- tem de sair da MESMA base, ou a cor compara grandezas
  // diferentes.
  const modo = data ? resolveCostNegotiationModeForRow(data, costNegotiationMode) : costNegotiationMode;

  const semFotografia = isClosedNegotiation && data ? isClosedRowWithoutCostSnapshot(data) : false;
  const { bestIdealPrice: bestPrice, bestIdealPricePMZ: bestPricePMZ } =
    data && !semFotografia ? idealPurchasePriceOf(data, modo) : { bestIdealPrice: null, bestIdealPricePMZ: null };

  // O custo comparado é o mesmo que a coluna "Custo atual" mostra: em custo de entrada, o de
  // entrada, que é a base em que o preço ideal acima foi calculado. Ler `cost` direto comparava
  // base de entrada com custo líquido, e apagava a cor quando a linha só trazia `entryCost`.
  const currentCost = data ? getCurrentInputCostForNegotiation(data, modo) : null;
  const hasTypedCost = data?.newCost !== null && data?.newCost !== undefined;
  const custoNegociado = hasTypedCost ? round(data?.newCost as number, 2) : currentCost !== null && currentCost !== undefined ? round(currentCost, 2) : 0;

  // A cor responde ao custo que o comprador de fato paga, e a verba acordada faz parte dele: sem
  // descontar, uma linha que a verba deixou boa continuava vermelha.
  const verbaAcordada = data ? getAgreedAllowanceInCostBase(data, modo) : 0;
  const costReference = round(custoNegociado - verbaAcordada, 2);

  const statusStyle = bestPrice !== null && costReference ? (costReference <= bestPrice ? 'positive' : 'negative') : 'default';

  const wrapperClass = isSupplierModal ? styles['preco-ideal-supplier-modal-wrapper'] : styles['preco-ideal-cell-wrapper'];

  return (
    <div className={wrapperClass}>
      <p className={styles[`text-status-${statusStyle}`]}>{bestPrice !== null ? formatCurrencyToPtBr(bestPrice) : 'R$ --'}</p>
      <p className={styles[`subtext-status-${statusStyle}`]}>PMZ {bestPricePMZ !== null ? formatCurrencyToPtBr(bestPricePMZ) : 'R$ --'}</p>
    </div>
  );
};
